export class DiscountCode {
    id: number;
    marketCode: string;
    effectiveBeginDate: Date;
    effectiveEndDate: Date;
    description: string;
    flatDiscount?: number;
    discountPercent?: number;
    memberGroups: string;
}
